import React from 'react';

import Resource from '../ResourcesList/Resource';

import './style.scss';

const ResourcesListLoading = () => {

  return (
    <div className="ResourcesListLoading">
      <Resource isEmpty />
      <Resource isEmpty />
      <Resource isEmpty />
    </div>
  );
};


export default ResourcesListLoading;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/ResourcesListLoading/index.js
 **/